// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"701feed0","489":"3035e29a"}[chunkId] + ".chunk.js";
};